module.exports = __webpack_public_path__ + "media/about/BloodConnectionLogo-be79cae1.png";